import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/useUserStore";
import { IEmailPreferenceGroup } from "@faire/web-api--source/com/faire/email/preferences/IEmailPreferenceGroup";
import { IEmailPreferenceSubgroup } from "@faire/web-api--source/com/faire/email/preferences/IEmailPreferenceSubgroup";
import { useQuery as useEmailPreferencesQuery } from "@faire/web-api--source/endpoints/www/api/email/preferences/get-hooks";
import { useMemo } from "react";

const useIsUnsubscribedToMarketingEmailsControl = () => {
  const { isUnsubscribedToMarketingEmails } = useRetailerStore([
    "isUnsubscribedToMarketingEmails",
  ]);

  return { isUnsubscribedToMarketingEmails };
};

const useIsUnsubscribedToMarketingEmailsTreatment = () => {
  const { emailAddress } = useUserStore(["emailAddress"]);

  const { data: emailPreferences } = useEmailPreferencesQuery({
    outgoing_email: emailAddress,
    requested_email_address_identifier: undefined,
  });
  const emailPreferenceGroups = emailPreferences?.email_preference_groups;
  const isAllEmailPreferenceGroupsUnsubscribed = useMemo((): boolean => {
    if (!emailPreferenceGroups) {
      return false;
    }
    return emailPreferenceGroups.every(
      (emailPreference: IEmailPreferenceGroup) => {
        return (
          emailPreference.subgroups?.every(
            (subgroup: IEmailPreferenceSubgroup) => {
              return subgroup.is_unsubscribed;
            }
          ) ?? false
        );
      }
    );
  }, [emailPreferenceGroups]);

  const isUnsubscribedToMarketingEmails =
    !!emailPreferences &&
    (emailPreferences.is_unsubscribed_from_all ||
      isAllEmailPreferenceGroupsUnsubscribed);

  return { isUnsubscribedToMarketingEmails };
};

export const useIsUnsubscribedToMarketingEmails = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useIsUnsubscribedToMarketingEmailsTreatment();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useIsUnsubscribedToMarketingEmailsControl();
};
